<template>
  <div class="customerList">
      <v-list :dense="dense" :class="primaryColor ? 'primary' : ''">
        <v-list-item
          v-for="customer in customers"
          :key="customer.id"
          @click="onClickCustomer(customer)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="getCustomerName(customer)"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
  </div>
</template>v-text="getCustomerName(customer)"

<script>
import customerName from '../mixins/customerName'
export default {
  name: 'CustomerList',
  mixins: [customerName],
  props: ['customers', 'onClickCustomer', 'dense', 'primaryColor'],
  data: () => ({
  })

}
</script>

<style scoped>
</style>
